/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import AssistantAndProvider from './AssistantAndProvider/index'
import Colors from './Colors/index'
import Hour from './Hour/index'
import Indicator from './Indicator/index'
import Location from './Location/index'
import Name from './Name/index'
import React from 'react'
import Status from './Status/index'
import Time from './Time/index'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/MoveToAnotherTreatment/Events/Content/Event/Appointment/Content",
  backgroundColor
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let moveResourcesAppointmentIdsValueData = fromData.useDataValue({ viewPath,
context: 'move_resources',
path: 'appointment_ids',
})
let appointmentIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: '_id',
})
let aggregateData = fromAggregate.includes(moveResourcesAppointmentIdsValueData, appointmentIdValueData)
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  backgroundColor
  
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let appointmentBookingStateValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'booking.state',
})
let constantData = 'SEATED'
let aggregateData1 = fromAggregate.equals(appointmentBookingStateValueData, constantData)
let appointmentUnplannedValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'unplanned',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsBlue600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.600'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="move_resources.appointment_ids"
 data="appointment._id"
 aggregate="/Data/aggregate.js includes"
 value={aggregateData}
 onChange={onChange}
>
{childProps => (
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
)}
</TysiaCheckbox>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--ml-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<Time
  viewPath={`${viewPath}/Time`}
/>
</div>
<Indicator
  viewPath={`${viewPath}/Indicator`}
/>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-3-Z1Yf8zk': dtColorsNeutral400,'--sc-4-Z1Yf8zk': dtColorsNeutral200,'--btlr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-8-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pt-9-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-10-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-11-Z1Yf8zk': backgroundColor,'--btlr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-7-Z1Yf8zk': aggregateData1 ? typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs : appointmentUnplannedValueData ? typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs : typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-8-Z1Yf8zk': aggregateData1 ? typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs : appointmentUnplannedValueData ? typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs : typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<div
  data-testid="Content.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<div
  data-testid="Content.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<Colors
  viewPath={`${viewPath}/Colors`}
/>
</div>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 style={{'--ml-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical2}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<div
  data-testid="Content.Horizontal:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal5}`}
>
<Hour
  viewPath={`${viewPath}/Hour`}
/>
<Location
  viewPath={`${viewPath}/Location`}
/>
</div>
<Status
  viewPath={`${viewPath}/Status`}
/>
</div>
</div>
<AssistantAndProvider
  viewPath={`${viewPath}/AssistantAndProvider`}
/>
</div>
</div>
</div>
</div>
{children}
</React.Fragment>)
}